module.exports = __webpack_public_path__ + "img/20190801164213103.5cc2ee2e.png";